<template>
  <div class="account-dealer">
    <div class="top-title">经销商账号管理</div>
    <!-- <Card> -->
    <div class="box" style="padding-top: 8px">
      <Dealerleft
        @cinput="meusInputChange"
        @change="menuchangeHandle"
        :nameList="namelist"
      />
      <!-- <div class="left-tree">
        <Input
          v-model="treeForm.value"
          @on-change="changeSearch"
          prefix="ios-search"
          placeholder="搜索"
        />
       
        <ul class="lists">
          <li
            v-for="(item, index) in treeLists"
            :key="index"
            @click="handleCheckChange(item, index)"
            :class="curRh === index ? 'cur' : ''"
          >
            {{ item.value }}
          </li>
        </ul>
      </div> -->
      <div class="right-trunk">
        <ul class="common-search li-margin">
          <li>
            <span>姓名: </span>
            <Input
              v-model="dataForm.nickname"
              @on-search="(e) => searchInput(e, 'nickname')"
              search
              placeholder="请输入"
            />
          </li>
          <li>
            <span>手机号: </span>
            <Input
              v-model="dataForm.mobile"
              @on-search="(e) => searchInput(e, 'mobile')"
              search
              placeholder="请输入"
            />
          </li>
          <li>
            <span>负责客户: </span>
            <Select
              v-model="dataForm.consumerTenantId"
              :label-in-value="true"
              :clearable="true"
              @on-change="(e) => changeSel(e, 'consumerTenantId')"
              placeholder="全部"
            >
              <Option
                :key="customer.id"
                :value="customer.id"
                v-for="customer in customerList"
                >{{ customer.value }}</Option
              >
            </Select>
          </li>
          <li>
            <span>账号状态: </span>
            <Select
              v-model="dataForm.status"
              :label-in-value="true"
              @on-change="(e) => changeSel(e, 'status')"
              :clearable="true"
              placeholder="全部"
            >
              <Option value="0">已禁用</Option>
              <Option value="1">已启用</Option>
            </Select>
          </li>
          <li class="dataPicker">
            <span>创建时间: </span>
            <DatePicker
              :clearable="false"
              @on-change="(e) => changeDate(e, 'date')"
              v-model="dataForm.date"
              type="daterange"
              format="yyyy-MM-dd"
              placeholder="请选择"
            />
          </li>
          <li class="dataPicker">
            <span>登录时间: </span>
            <DatePicker
              :clearable="false"
              @on-change="(e) => changeDate(e, 'dates')"
              v-model="dataForm.dates"
              type="daterange"
              format="yyyy-MM-dd"
              placeholder="请选择"
            />
          </li>
          <li class="searchItem">
            <Button class="sels-item" @click="resetData">重置</Button>
          </li>
        </ul>
        <div class="common-selects selected-margin" v-if="selItems.length">
          <span class="tit">已选:</span>
          <span class="sel" v-for="(item, index) in selItems" :key="index"
            >{{ item.val }}
            <Icon @click="delSelItem(item, index)" type="md-close-circle" />
          </span>
        </div>
        <div class="lists clearfix list-margin">
          <Button type="primary" @click="addDealer" v-if="!!pageInfo.tenantId">
            <Icon type="md-add" />新增用户
          </Button>
          <div class="common-list table-margin">
            <Table
              class="meifuTable"
              :columns="dataColumn"
              :data="dataLists"
              @on-selection-change="selectChange"
            >
            </Table>
          </div>
          <div>
            <Button
              @click="batchEnable"
              style="margin-right: 16px"
              :disabled="dealerStatus"
              >启用</Button
            >
            <Button @click="batchDsiable" :disabled="dealerStatus">禁用</Button>
            <div class="common-page fr">
              <Page
                show-total
                show-elevator
                show-sizer
                :total="pageInfo.total"
                :current="pageInfo.current"
                :page-size="pageInfo.size"
                @on-change="getLists"
                @on-page-size-change="changeSize"
              ></Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </Card> -->
    <DealerDrawer
      ref="dealerDrawer"
      :showDrawer="showDrawer"
      :closeDrawer="closeDrawer"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
      :tenantId="pageInfo.tenantId"
      :customerList="customerList"
      :dataCenter="dataCenter"
    >
    </DealerDrawer>
  </div>
</template>

<script>
//经销商管理员
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import { mapState } from "vuex";
import handleSelItem from "@/mixins/handleSelItem";
import DealerDrawer from "./components/dealer-drawer.vue";
import sizeData from "@/mixins/sizeData";
import moment from "moment";
import Dealerleft from "./components/dealer-left.vue";
import debounce from "@/util/debounce.js";
import PhoneNumber from '@/components/PhoneNumber/index'
export default {
  name: "account-dealer",
  mixins: [handleSelItem, sizeData],
  components: {
    DealerDrawer,
    Dealerleft,
    PhoneNumber
  },
  computed: {
    ...mapState({
      dataCenter: (state) => state.dataCenter,
    }),
  },
  data() {
    return {
      namelist: [],
      map: {
        customer_user: "普通用户",
        customer_administrator: "管理员",
        agency_user: "普通用户",
        agency_administrator: "管理员",
        mobil_user: "普通用户",
        mobil_administrator: "管理员",
      },
      customerList: {},
      consumer: [],
      userRole: ls.get("userRole"),
      selItems: [],
      treeLists: [],
      dataForm: {},
      pageInfo: {
        size: 10,
        current: 1,
        total: 0,
        tenantId: "",
      },
      form: {
        status: 0,
        ids: [],
      },
      treeForm: {
        value: "",
        type: "agency",
        size: 200,
      },
      dealerStatus: true,
      showDrawer: false,
      curItemDetail: {},
      curRh: 0,
      selItems: [],
      dataLists: [],
      dataColumn: [
        {
          type: "selection",
          width: 60,
          fixed: "left",
        },
        {
          title: "序号",
          type: "index",
          width: 80,
          fixed: "left",
        },
        {
          title: "姓名",
          key: "nickname",
          width: 150,
          fixed: "left",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.nickname || "-");
          },
        },
        {
          title: "手机号",
          width: 180,
          key: "mobile",
          render: (h, params) => {
            const item = params.row;
            return (
              <PhoneNumber phone={item.mobile}  />
            )
          },
        },
        {
          title: "角色",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "8px",
                  },
                },
                this.map[params.row.authorityString] || "-"
              ),
            ]);
          },
        },
        {
          title: "负责客户",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "8px",
                  },
                },
                params.row.consumerList
                  .map((item) => item.companyName)
                  .join("、") || "-"
              ),
            ]);
          },
        },
        {
          title: "账号状态",
          width: 150,
          render: (h, params) => {
            // let boolType = false;
            // if (
            //     params.row.authorityString.indexOf(
            //         "administrator"
            //     ) > -1
            // )
            //     boolType = true;
            // else boolType = false;
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "8px",
                  },
                },
                params.row.status == 1 ? "已启用" : "已禁用"
              ),
              h(
                "i-switch",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    value: params.row.status,
                    "true-value": 1,
                    "false-value": 0,
                    // disabled: boolType,
                    beforeChange: this.handleBeforeChange,
                    "true-color": "#1E8E3E ",
                  },
                  on: {
                    "on-change": (value) => {
                      // 状态更新
                      this.form.ids = [];
                      this.form.ids.push(params.row.id);
                      this.form.status = value;
                      this.form.smsAlarm = undefined;
                      this.batchDealer();
                    },
                  },
                  nativeOn: {
                    mousedown: () => {
                      // 监听组件原生事件mousedown,此事件在click之前触发
                      this.switchOneInfo = {
                        value: params.row.status,
                      };
                    },
                  },
                },
                ""
              ),
            ]);
          },
        },
        //   {
        //   title: "报警短信通知",
        //   width: 150,
        //   render: (h, params) => {
        //     let boolType = false;
        //     // if (
        //     //   params.row.authorityString.indexOf(
        //     //     "administrator"
        //     //   ) > -1
        //     // )
        //     //   boolType = true;
        //     // else boolType = false;
        //     if(params.row.authSmsAlarm==0){
        //       boolType = true;
        //     }
        //     return h("div", [
        //       h(
        //         "span", {
        //           style: {
        //             marginRight: "8px",
        //           },
        //         },
        //         params.row.smsAlarm == 1 ? "已启用" : "已禁用"
        //       ),
        //       h(
        //         "i-switch", {
        //           props: {
        //             type: "primary",
        //             size: "small",
        //             value:  Number(params.row.smsAlarm),
        //             "true-value": 1,
        //             "false-value": 0,
        //             disabled: boolType,
        //             beforeChange: this.handleBeforeChange1,
        //             "true-color": "#1E8E3E ",
        //           },
        //           on: {
        //             "on-change": (value) => {
        //               // 状态更新
        //               this.form.ids = [];
        //               this.form.ids.push(params.row.id);
        //               this.form.smsAlarm = value.toString();
        //                this.form.status=undefined
        //               this.batchDealer();
        //             },
        //           },
        //           nativeOn: {
        //             mousedown: () => {
        //               // 监听组件原生事件mousedown,此事件在click之前触发
        //               this.switchOneInfo = {
        //                 value: params.row.status,
        //               };
        //             },
        //           },
        //         },
        //         ""
        //       ),
        //     ]);
        //   },
        // },
        {
          title: "创建时间",
          width: 200,
          key: "gmtCreate",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.gmtCreate || "-");
          },
        },
        {
          title: "最新登录时间",
          width: 200,
          key: "latestLoginTimeWeb",
          render: (h, params) => {
            const item = params.row;
            let latestLoginTimeWeb = item.latestLoginTimeWeb || 0;
            let latestLoginTimeWebchat = item.latestLoginTimeWebchat || 0;

            let lastformate = this.$moment(latestLoginTimeWeb).valueOf();
            let wxformate = this.$moment(latestLoginTimeWebchat).valueOf();
            let str;
            if (lastformate == 0 && wxformate == 0) {
              str = "-";
            } else if (lastformate > wxformate) {
              str = latestLoginTimeWeb;
            } else {
              str = latestLoginTimeWebchat;
            }
            return h("div", str);
          },
        },
        {
          title: "备注",
          key: "remark",
          width: 300,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.remark || "-");
          },
        },
        {
          title: "操作",
          key: "address",
          align: "left",
          fixed: "right",
          width: 150,
          className: "action",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0C479DFF",
                    cursor: "pointer",
                    display:
                      params.row.authorityString !== "agency_administrator"
                        ? "inline-block"
                        : "none",
                  },
                  on: {
                    click: () => {
                      this.editDealer(params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                    display:
                      params.row.authorityString !== "agency_administrator"
                        ? "inline-block"
                        : "none",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0C479DFF",
                    cursor: "pointer",
                    display:
                      params.row.authorityString !== "agency_administrator"
                        ? "inline-block"
                        : "none",
                  },
                  on: {
                    click: () => {
                      this.delDealer(this.$c.deepClone(params.row));
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.getTree();
    // this.getCustomer();
    if (!['c0', 'c1'].includes(this.userRole)) {
      this.$store.dispatch("listCollection", "consumer"); // 客户
    }
  },
  methods: {
    meusInputChange(row) {
      debounce(() => {
        this.treeForm.value = row.value;
        this.$nextTick(() => {
          this.getTree();
        });
      });
    },
    menuchangeHandle({ row }) {
      this.$store.state.spinShow = true;
      this.pageInfo.tenantId = row.value;
      this.getLists();
    
      this.$store.state.spinShow = false;
    },
    getLists(page) {
      if (page) this.pageInfo.current = page;
      api
        .axss("post", "/ocm-admin/user/page", {
          ...this.pageInfo,
          ...this.dataForm,
        })
        .then((res) => {
          if (res.code === "00000") {
            const datas = res.data;
            this.dataLists = datas.records;
            this.pageInfo.total = datas.total;
            this.getCustomer(this.pageInfo.tenantId);
          }
        });
    },
    changeSize(data) {
      this.pageInfo.size = data;
      this.getLists();
    },
    getCustomer(aid) {
      // api.axss("get", "/ocm-admin/tenant/consumer/agency/page").then(
      //     (res) => {
      //         if (res.code === "00000") {
      //             const datas = res.data;
      //             this.customerList = datas.records;
      //         }
      //     }
      // );

      // 加载所选经销商的客户
      const datas = {
        size: 200,
        type: "consumer",
        gangedValueMap: {
          agencyId: aid,
        },
      };
      api
        .axss("get", `/ocm-admin/tenant/agencyConsumer?agencyId=${aid}`, datas)
        .then((res) => {
          if (res.code === "00000") {
            this.customerList = res.data.map((item) => {
              return {
                value: item.companyName,
                id: item.consumerTenantId,
              };
            });
          }
        });
    },
    getTree() {
      this.$store.state.spinShow = true;
      api.axss("post", "/ocm-admin/select", this.treeForm).then((res) => {
        if (res.code === "00000") {
          const datas = res.data;
          let list = datas.records;
          if (list.length) {
            // datas.records[0].selected = true;
            this.pageInfo.tenantId = list[0].id || "";
            let namelist = this.$c
              .ySegSort(list.map((e) => e.value))
              .map((item) => {
                item.data = item.data.map((e1) => {
                  let finitem = list.find((finde) => finde.value == e1);
                  return {
                    lable: e1,
                    value: finitem.id,
                  };
                });
                item.bo = false;
                return item;
              });
            namelist[0].bo = true;
            this.namelist = namelist;
            this.getLists();
          } else {
            this.nameList = [];
          }
          // this.treeLists = datas.records;
          // if (this.pageInfo.tenantId) this.getLists();
          // this.curRh = 0;
          this.$store.state.spinShow = false;
        }
      });
    },
    // getTree() {
    //   this.$store.state.spinShow = true;
    //   api.axss("post", "/ocm-admin/select", this.treeForm).then((res) => {
    //     if (res.code === "00000") {
    //       const datas = res.data;
    //       if (datas.records.length) {
    //         datas.records[0].selected = true;
    //         this.pageInfo.tenantId = datas.records[0].id || "";
    //       }
    //       this.treeLists = datas.records;
    //       if (this.pageInfo.tenantId) this.getLists();
    //       this.curRh = 0;
    //       this.$store.state.spinShow = false;
    //     }
    //   });
    // },
    changeSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getTree();
      }, 500);
    },
    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%",
            cursor: "pointer",
          },
        },
        [h("span", [h("span", data.value)])]
      );
    },
    // handleCheckChange(data) {
    //     this.pageInfo.tenantId = data[0].id;
    //     this.getLists(1);
    // },
    handleCheckChange(details, index) {
      if (this.curRh === index) return;
      this.pageInfo.tenantId = details.id;
      this.curRh = index;
      this.getLists(1);
    },
    searchInput(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeSel(val, name) {
      this.selItems = this.handleSelItem(val.label, name);
      this.getLists(1);
    },
    changeDate(date, name) {
      if (name === "date") {
        this.dataForm.gmtCreateDateStart = date[0];
        this.dataForm.gmtCreateDateEnd = date[1];
        this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      }
      if (name === "dates") {
        this.dataForm.localDateTimeStart = date[0];
        this.dataForm.localDateTimeEnd = date[1];
        this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      }
      this.getLists(1);
    },
    handleBeforeChange() {
      return new Promise((resolve) => {
        this.$Modal.confirm({
          title: "您确定要切换账号状态吗？",

          onOk: () => {
            resolve();
          },
        });
      });
    },
    handleBeforeChange1() {
      return new Promise((resolve) => {
        this.$Modal.confirm({
          title: "您确定要切换短信通知状态吗？",

          onOk: () => {
            resolve();
          },
        });
      });
    },
    selectChange(selection) {
      this.form.ids = [];
      selection.forEach((item) => {
        this.form.ids.push(item.id);
      });
      if (this.form.ids.length > 0) this.dealerStatus = false;
      else this.dealerStatus = true;
    },
    batchEnable() {
      this.form.status = 1;
      this.$Modal.confirm({
        title: "您确定要批量启用这些用户吗？",
        onOk: () => {
          this.batchDealer();
          this.dealerStatus = true;
        },
        onCancel: () => {
          this.$Message.info("已取消处理");
        },
      });
    },
    batchDsiable() {
      this.form.status = 0;
      this.$Modal.confirm({
        title: "您确定要批量禁用这些用户吗？",
        onOk: () => {
          this.batchDealer();
          this.dealerStatus = true;
        },
        onCancel: () => {
          this.$Message.info("已取消处理");
        },
      });
    },
    batchDealer() {
      api.axss("post", "/ocm-admin/user/batchStatus", this.form).then((res) => {
        if (res.code === "00000") {
          this.$Message.success("处理成功");
          this.getLists();
        }
      });
    },
    delDealer(data) {
      this.curItemDetail = data;
      this.$Modal.confirm({
        title: "您确定要删除该用户吗？",
        content: `用户姓名：${data.nickname}`,
        onOk: () => {
          this.delItem();
        },
        onCancel: () => {},
      });
    },
    delItem() {
      api
        .axss("delete", `/ocm-admin/user/${this.curItemDetail.id}`)
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("删除成功");
            this.curItemDetail = {};
            const finalSize = this.sizeData(
              this.pageInfo.size,
              this.pageInfo.current,
              this.pageInfo.total
            );
            this.getLists(finalSize);
          }
        });
    },
    addDealer() {
      this.curItemDetail = {};
      this.showDrawer = true;
    },
    editDealer(item) {
      this.curItemDetail = deepcopy(item);
      this.showDrawer = true;
    },
    closeDrawer() {
      this.showDrawer = false;
      this.curItemDetail = {};
    },
    delSelItem(selItem, index) {
      this.dataForm[selItem.name] = null;
      //日期需要单独处理
      if (selItem.name === "date") {
        delete this.dataForm.gmtCreateDateStart;
        delete this.dataForm.gmtCreateDateEnd;
      }
      if (selItem.name === "dates") {
        delete this.dataForm.localDateTimeStart;
        delete this.dataForm.localDateTimeEnd;
      }
      this.selItems.splice(index, 1);
      this.getLists(1);
    },
    resetData() {
      this.reset("dataForm");
      this.getLists(1);
    },
    reset(key) {
      this.selItems = [];
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
  },
};
</script>

<style lang='less'>
.account-dealer {
  width: 100%;

  .box {
    display: flex;

    .left-tree {
      width: 15%;
      min-height: 460px;
      overflow: auto;

      .ivu-input-wrapper {
        .ivu-input {
          border: none;
          border-bottom: 1px solid #dcdee2;
          border-radius: 0;
          box-shadow: none !important;
        }
      }

      .ivu-tabs-nav-wrap {
        .ivu-tabs-nav {
          .ivu-tabs-tab {
            padding: 16px;
          }
        }
      }

      .lists {
        li {
          padding: 10px 18px;
          cursor: pointer;

          &:hover {
            background-color: #f5f5f5;
          }

          &.cur {
            background-color: #f5f5f5;
          }
        }
      }
    }

    .right-trunk {
      width: 85%;
      border-left: 1px solid #dcdee2;
      padding-left: 16px;
    }
  }
}
</style>